import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import { useErrorInline } from '@/context/InlineErrorContext/InlineErrorContext';
import { BusinessDocumentDetail } from '@/context/services/business_document/type';
import { useBusinessDocumentButtonActions } from '@/features/business_documents/Detail/components/hooks/useBusinessDocumentButtonActions';
import { HeaderButtons } from '@/features/business_documents/Detail/components/Right/HeaderButton';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './DrawerTitle.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  data: BusinessDocumentDetail;
};

export const DrawerTitle: FC<Props> = memo(({ data }) => {
  const { setError } = useErrorInline();
  const { onArchiveClick, onRestoreArchiveClick, copyIdUrl } =
    useBusinessDocumentButtonActions(data, setError);
  const flag = useGetFlags('RELATION_FEATURE');

  return (
    <div className={cx(styles['container'])}>
      <div className={cx(styles['fileName-container'])}>
        <FileNameSeparatorWithExtension>
          {data.mf_file?.name ?? ''}
        </FileNameSeparatorWithExtension>
      </div>
      <div className={cx(styles['button-container'])}>
        <HeaderButtons
          onArchiveClick={onArchiveClick}
          copyText={copyIdUrl}
          onArchiveRestoreClick={onRestoreArchiveClick}
          hasInvoiceReports={!!data.invoice_reports?.length && flag}
        />
      </div>
    </div>
  );
});
DrawerTitle.displayName = 'DrawerTitle';
